import React from "react";
import {Col} from "reactstrap";


export default function MainContentWrapper({noSidebar=false, children}) {
    return <Col lg={noSidebar ? 12 : 8} xl={noSidebar ? 12 : 8} xxl={ noSidebar ? 12 : 9}>
        {children}
    </Col>
}